import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone' // load on demand
import { mapGetters } from 'vuex'
import store from '~/store'
import utils from '../utilities'

dayjs.extend(timezone)

const isBetween = require('dayjs/plugin/isBetween')

dayjs.extend(isBetween)

export default {
  data() {
    return {
      initializedStatus: false,
      selectedTemplate: null,
      tzDisplay: null,
      template: null,
      SessionStatus: null,
    }
  },
  computed: {
    ...mapGetters({
      configForKey: 'config/configForKey',
    }),
    statusConfig() {
      const appConfig = this.configForKey('app_config')
      if (appConfig.statusConfig) {
        return appConfig.statusConfig
      }
      return null
    },
    sessionLabel() {
      const appConfig = this.configForKey('app_config')
      if (appConfig.configV2 && appConfig.configV2.defaultV2 && appConfig.configV2.defaultV2.sessionLabel) {
        return appConfig.configV2.defaultV2.sessionLabel
      }
      return null
    },
    ignoreListConfig() {
      const appConfig = this.configForKey('app_config')
      if ('ignoreLabelList' in appConfig.configV2.defaultV2) {
        return appConfig.configV2.defaultV2.ignoreListConfig
      }
      return ['MyAreaPage', 'PagPersonalProgrammePage']
    },
    sessionLabelInPag() {
      const appConfig = this.configForKey('app_config')
      if (!('sessionLabelInPag' in appConfig.configV2.defaultV2)) {
        return true
      }
      if (appConfig.configV2.defaultV2.sessionLabelInPag && (localStorage.getItem('isVMX') === 'true' || localStorage.getItem('isApp') === 'true')) {
        return false
      }
      return true
    },
    templateConfig() {
      const appConfig = this.configForKey('app_config')
      if (appConfig.configV2 && appConfig.configV2.defaultV2 && appConfig.configV2.defaultV2.defaultTemplate) {
        return appConfig.configV2.defaultV2.defaultTemplate
      }
      return {
        showInformationBox: true,
        showSessionRecording: true,
        isLive: true,
        showWatchButton: true,
        showLiveSection: true,
        showOnDemandSection: true,
        liveText: 'AppTranslations.LiveTitle',
        liveButtonText: 'AppTranslations.WatchStream',
        onDemandButtonText: 'VMX.watch_on_demand_btn_label',
        liveTimeLabelText: 'AppTranslations.JoinDiscussionTitle',
        showOnDemandTimeInformation: true,
        onDemandText: 'AppTranslations.OnDemandTitle',
        onDemandTimeLabelText: 'AppTranslations.AvailableFrom',
        webcastText: 'VMX_Status.lblOndemandContent_template_1',
        noWebcastText: 'VMX_Status.lblNoOndemandContent_template_1',
        noWebcastEnabledText: 'VMX_Status.lblNoWebcastEnabledContent_template_1',
        suppressedWebcastText: 'VMX_Status.lblsuppressedContent_template_1',
        noPermissionWebcastText: 'VMX_Status.lblNoPermissionContent_template_1',
        noWebcastPreviewThumbnail: '',
        suppressedWebcastThumbnail: '',
        noPermissionWebcastThumbnail: '',
        previewThumbnail: '',
      }
    },
    assignments() {
      if (this.statusConfig) {
        return this.statusConfig.assignments
      }
      return null
    },
    templates() {
      if (this.statusConfig) {
        return this.statusConfig.templates
      }
      return null
    },
  },
  methods: {
    assignPropTemplate() {
      this.template = this.templateConfig
    },
    changeSessionLabel(session) {
      let label = session.TextWithFormat
      if(this.ignoreListConfig.includes(this.$route.name)) return label
      if (this.sessionLabelInPag && this.sessionLabel) {
        this.sessionLabel.forEach((setting) => {
          switch (setting.Identifier) {
            case 'SessionType':
            {
              if (setting.includes.some((type) => type === session.SessionTypeName)) {
                label = this.$route.query.name === 'reveal' ? label : setting.alternativeText
              }
              break
            }
            case 'SessionId':
            {
              if (setting.includes.some((id) => id === session.SessionId)) {
                label = this.$route.query.name === 'reveal' ? label : setting.alternativeText
              }
              break
            }
            default:
            {
              return label
            }
          }
        })
      }
      return label
    },
    timeZoneName(time, location) {
      let locale = this.$route.params.language ? this.$route.params.language : store.getters['instancesState/getLanguage']
      const { config } = this.configForKey('app_config')
      const { hideTimeZoneInfo } = config[0]
      const { showInsteadOfTimeZone } = config[0]
      const { alternativeTimezoneText } = config[0]
    // Insert timezone mixins here

      if (hideTimeZoneInfo) {
        return ''
      }
      if (showInsteadOfTimeZone && showInsteadOfTimeZone.isActive) {
        return showInsteadOfTimeZone.insteadText || ''
      }
      let selectedTimezone 
      switch (location) {
        case 'local':
          selectedTimezone = localStorage.getItem('userTimeZone')
        break
        case 'event':
          selectedTimezone = utils.eventTimezone()
          break
        default:
          selectedTimezone = utils.selectedTimezone()
          break
      }
     
      if (locale == 'fr-FR') {
        locale = 'en-GB';
      }

      const forceEnGB = locale === ('en-US' || 'fr-FR') ? 'en-GB' : locale
      // eslint-disable-next-line prefer-destructuring
      let display = ''
      this.tzDisplay = new Intl.DateTimeFormat(
        forceEnGB,
        {
          timeZoneName: 'long',
          timeZone: selectedTimezone,
        },
      ).formatToParts().find(part => part.type ==='timeZoneName').value

      if (this.tzDisplay.split(' ').length > 1) {
        display =  this.tzDisplay.split(' ').map((item) =>  item[0]).join('');
      } else {
        display =  this.tzDisplay.split(' ')[0]
      }
      this.tzDisplayLong = new Intl.DateTimeFormat(
        forceEnGB,
        {
          timeZoneName: 'long',
          timeZone: selectedTimezone,
        },
      ).formatToParts().find(part => part.type ==='timeZoneName')
      localStorage.setItem('selectedTimezoneName', this.tzDisplayLong.value)
      return display.toUpperCase()
      
      
      
    },
    selectTemplateViaTime(pSessionId, pStartDate, pEndDate) {
      const eventTimezone = utils.eventTimezone()
      const selectedTimezone = utils.selectedTimezone()
      this.assignPropTemplate()
      if (this.assignments) {
        this.SessionStatus = (this.assignments.find((assignment) => assignment.sessionIds.includes(pSessionId)) ? this.assignments.find((assignment) => assignment.sessionIds.includes(pSessionId)) : this.assignments[0]).states

        const serverTime = store.getters['serverTime/getTime']
        const nowDate = dayjs.tz(dayjs(serverTime), eventTimezone)

        let dayjsStartDate
        let dayjsEndDate
        if (selectedTimezone === eventTimezone) {
          dayjsStartDate = dayjs(pStartDate).tz(eventTimezone, true)
          dayjsEndDate = dayjs(pEndDate).tz(eventTimezone, true)
        } else {
          dayjsStartDate = dayjs(pStartDate).tz(eventTimezone)
          dayjsEndDate = dayjs(pEndDate).tz(eventTimezone)
        }

        const isBeforeEndDate = nowDate.isBefore(dayjsEndDate)
        // if true then take cueoffsettype sessionstart, if false take sessionend
        if (isBeforeEndDate) {
          for (let i = 0; i < this.SessionStatus.length; i += 1) {
            if (nowDate.isBefore(dayjsStartDate.add(this.SessionStatus[0].cueOffset.value, 'minute'))) {
              this.selectedTemplate = this.SessionStatus[0].templateIdentifier
            }
            if (this.SessionStatus[i].cueOffset.type === 'SessionStart' && nowDate.isAfter(dayjsStartDate.add(this.SessionStatus[i].cueOffset.value, 'minute'))) {
              this.selectedTemplate = this.SessionStatus[i].templateIdentifier
            }
            if (this.SessionStatus[i].cueOffset.type === 'SessionEnd') {
              break
            }
          }
        } else {
          for (let i = 0; i < this.SessionStatus.length; i += 1) {
            if (nowDate.isAfter(dayjsEndDate.add(this.SessionStatus[this.SessionStatus.length - 1].cueOffset.value, 'minute'))) {
              this.selectedTemplate = this.SessionStatus[this.SessionStatus.length - 1].templateIdentifier
            }

            if (this.SessionStatus[i].cueOffset.type === 'SessionEnd' && nowDate.isAfter(dayjsEndDate.add(this.SessionStatus[i].cueOffset.value, 'minute'))) {
              this.selectedTemplate = this.SessionStatus[i].templateIdentifier
            }
          }
        }
        if (this.selectedTemplate) {
          this.template = this.templates[this.selectedTemplate]
        }
      }
      this.initializedStatus = true
    },
    activateComponentForAbstract() {
      this.initializedStatus = true
    },
  },
}
